/* istanbul ignore file */
export enum SupplyTypeEnum {
	POWER = 'Energy',
	GAS = 'Gas',
	WATER = 'Water',
	TELECOM = 'telecom',
	ALARMS = 'alarms'
}
